var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.formContent.formGrupoPergunta),function(group){return _c('question-group-component',{key:group.id,attrs:{"group":group}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }